import DashboardLayout from "../../components/layout/DashboardLayout";
import { useParams } from "react-router";
import Subscription from "../../components/pricing-plan/Subscription";
import IndividualServices from "../../components/pricing-plan/IndividualServices";
import Referrals from "../../components/pricing-plan/Referrals";

function PricingBillingIndex() {
  const { section } = useParams();

  const isInSubscriptionTab =
    section === "subscription" || section === undefined;
  const isInActivateServiceTab = section === "activate-services";
  const isInReferralsTab = section === "referrals";

  return (
    <DashboardLayout>
      <div>
        {isInSubscriptionTab && <Subscription />}
        {isInActivateServiceTab && <IndividualServices />}
        {isInReferralsTab && <Referrals />}
      </div>
    </DashboardLayout>
  );
}

export default PricingBillingIndex;
